import { StyledCheckBox } from "./table.styles";
import { ColumnDef } from "@tanstack/react-table";
import { DefaultRow } from "./types";

const buildSelectColumn = <TRow extends DefaultRow>(): ColumnDef<TRow> => {
  return {
    id: "select",
    size: 40,
    enableSorting: false,

    header: ({ table }) => (
      <StyledCheckBox
        checked={table.getIsAllRowsSelected()}
        value={"all-selected"}
        onChange={table.getToggleAllRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => (
      <StyledCheckBox
        checked={row.getIsSelected()}
        value={row.id}
        onChange={row.getToggleSelectedHandler()}
      />
    ),
  };
};
export const buildFormattedColumns = <TRow extends DefaultRow>(
  columns: ColumnDef<TRow>[],
  hasSelectRows: boolean
) => {
  if (hasSelectRows) {
    return [buildSelectColumn<TRow>(), ...columns];
  }
  return columns;
};
